"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
// (C) 2019 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var react_intl_1 = require("react-intl");
var DropdownControl_1 = tslib_1.__importDefault(require("./DropdownControl"));
var dropdowns_1 = require("../../constants/dropdowns");
var translations_1 = require("../../utils/translations");
var DataLabelsControl = /** @class */ (function (_super) {
    tslib_1.__extends(DataLabelsControl, _super);
    function DataLabelsControl() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DataLabelsControl.prototype.render = function () {
        var _a, _b, _c;
        var _d = this.props, pushData = _d.pushData, properties = _d.properties, intl = _d.intl, isDisabled = _d.isDisabled, showDisabledMessage = _d.showDisabledMessage, defaultValue = _d.defaultValue;
        var dataLabels = (_c = (_b = (_a = properties === null || properties === void 0 ? void 0 : properties.controls) === null || _a === void 0 ? void 0 : _a.dataLabels) === null || _b === void 0 ? void 0 : _b.visible) !== null && _c !== void 0 ? _c : defaultValue;
        return (react_1.default.createElement("div", { className: "s-data-labels-config" },
            react_1.default.createElement(DropdownControl_1.default, { value: dataLabels, valuePath: "dataLabels.visible", labelText: "properties.canvas.dataLabels", disabled: isDisabled, properties: properties, pushData: pushData, items: translations_1.getTranslatedDropdownItems(dropdowns_1.dataLabelsDropdownItems, intl), showDisabledMessage: showDisabledMessage })));
    };
    DataLabelsControl.defaultProps = {
        defaultValue: "auto",
        showDisabledMessage: false,
    };
    return DataLabelsControl;
}(react_1.default.Component));
exports.default = react_intl_1.injectIntl(DataLabelsControl);
//# sourceMappingURL=DataLabelsControl.js.map